/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
/**
 * To modify the labels and text displayed, create a new instance of MatSortHeaderIntl and
 * include it in a custom provider.
 */
export class MatSortHeaderIntl {
    constructor() {
        /**
         * Stream that emits whenever the labels here are changed. Use this to notify
         * components if the labels have changed after initialization.
         */
        this.changes = new Subject();
        /**
         * ARIA label for the sorting button.
         */
        this.sortButtonLabel = (id) => {
            return `Change sorting for ${id}`;
        };
        /**
         * A label to describe the current sort (visible only to screenreaders).
         */
        this.sortDescriptionLabel = (id, direction) => {
            return `Sorted by ${id} ${direction == 'asc' ? 'ascending' : 'descending'}`;
        };
    }
}
MatSortHeaderIntl.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
MatSortHeaderIntl.ctorParameters = () => [];
function MatSortHeaderIntl_tsickle_Closure_declarations() {
    /** @type {?} */
    MatSortHeaderIntl.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    MatSortHeaderIntl.ctorParameters;
    /**
     * Stream that emits whenever the labels here are changed. Use this to notify
     * components if the labels have changed after initialization.
     * @type {?}
     */
    MatSortHeaderIntl.prototype.changes;
    /**
     * ARIA label for the sorting button.
     * @type {?}
     */
    MatSortHeaderIntl.prototype.sortButtonLabel;
    /**
     * A label to describe the current sort (visible only to screenreaders).
     * @type {?}
     */
    MatSortHeaderIntl.prototype.sortDescriptionLabel;
}
//# sourceMappingURL=sort-header-intl.js.map